import { z } from 'zod';
import { IsoDatetimeToDateSchema, NullableIsoDatetimeToDateSchema } from './date-codecs.js';
import { VerifiedTypeSchema } from './followers.js';
import { SummaryCustomPromptSchema } from './tweet-summary.js';
import { TwitterApiTweetSchema } from './twitter-api.js';

export const ConversationDataSourceSchema = z.enum(['twitterSearch', 'twitterGraphql', 'database']);
export type ConversationDataSource = z.infer<typeof ConversationDataSourceSchema>;

export const ConversationSummarySchema = z.object({
  id: z.string(),
  rootTweetId: z.string(),
  tweetCount: z.number(),
  participantCount: z.number(),
  maxDepth: z.number(),
  lastActivityAt: NullableIsoDatetimeToDateSchema,
  isComplete: z.boolean().default(false),
  dataSources: z.array(ConversationDataSourceSchema).default(['twitterSearch']),
  missingTweets: z.boolean().optional(),
});
export type ConversationSummary = z.infer<typeof ConversationSummarySchema>;

export const ConversationProfileSchema = z
  .object({
    id: z.string(),
    username: z.string(),
    name: z.string(),
    profileImageUrl: z.string().nullable().optional(),
    verifiedType: VerifiedTypeSchema.default('none'),
    createdAt: IsoDatetimeToDateSchema.optional(),
  })
  .passthrough();
export type ConversationProfile = z.infer<typeof ConversationProfileSchema>;

export const ConversationResponseSchema = z.object({
  conversation: ConversationSummarySchema,
  tweets: z.record(z.string(), TwitterApiTweetSchema),
  profiles: z.record(z.string(), ConversationProfileSchema),
  tweetIds: z.array(z.string()),
});
export type ConversationResponse = z.infer<typeof ConversationResponseSchema>;

export const ConversationSummaryRequestSchema = z
  .object({
    includeImages: z.boolean().optional(),
    customPrompt: SummaryCustomPromptSchema.optional(),
  })
  .default({});

export type ConversationSummaryRequest = z.infer<typeof ConversationSummaryRequestSchema>;
